module.exports = __webpack_public_path__ + "img/team-3.9a8d831b.jpg";